var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15279_8291)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2245 21.2834C16.7299 21.2834 17.2183 21.2508 17.6806 21.19V16.1236C17.2184 16.0629 16.7299 16.0303 16.2245 16.0303C13.3391 16.0303 11 17.0911 11 18.3999V18.9138C11 20.2224 13.3391 21.2834 16.2245 21.2834Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2245 23.9288C16.7299 23.9288 17.2183 23.8962 17.6806 23.8355V22.3505C17.2182 22.4112 16.73 22.4443 16.2245 22.4443C13.7059 22.4443 11.6037 21.6359 11.1099 20.56C11.038 20.7167 11 20.879 11 21.0454V21.5593C11 22.868 13.3391 23.9288 16.2245 23.9288Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6806 25.1115V24.996C17.2182 25.0568 16.73 25.0899 16.2245 25.0899C13.7059 25.0899 11.6037 24.2815 11.1099 23.2056C11.038 23.3623 11 23.5245 11 23.6909V24.2048C11 25.5135 13.3391 26.5744 16.2245 26.5744C16.8016 26.5744 17.3566 26.5319 17.8756 26.4535C17.7469 26.1904 17.6806 25.9128 17.6806 25.6253V25.1115Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7577 12.017C20.8723 12.017 18.5332 13.0778 18.5332 14.3866V14.9005C18.5332 16.2092 20.8723 17.2701 23.7577 17.2701C26.6431 17.2701 28.9822 16.2092 28.9822 14.9005V14.3866C28.9822 13.0778 26.6431 12.017 23.7577 12.017Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7577 18.431C21.2391 18.431 19.1369 17.6227 18.6431 16.5467C18.5712 16.7034 18.5332 16.8657 18.5332 17.0321V17.546C18.5332 18.8547 20.8723 19.9156 23.7577 19.9156C26.6431 19.9156 28.9822 18.8547 28.9822 17.546V17.0321C28.9822 16.8657 28.9443 16.7034 28.8724 16.5467C28.3786 17.6227 26.2764 18.431 23.7577 18.431Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7577 21.0766C21.2391 21.0766 19.1369 20.2682 18.6431 19.1923C18.5712 19.349 18.5332 19.5112 18.5332 19.6776V20.1915C18.5332 21.5003 20.8723 22.5612 23.7577 22.5612C26.6431 22.5612 28.9822 21.5003 28.9822 20.1915V19.6776C28.9822 19.5112 28.9443 19.349 28.8724 19.1923C28.3786 20.2682 26.2764 21.0766 23.7577 21.0766Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7577 23.8649C21.2391 23.8649 19.1369 23.0565 18.6431 21.9806C18.5712 22.1374 18.5332 22.2996 18.5332 22.4659V22.9799C18.5332 24.2886 20.8723 25.3495 23.7577 25.3495C26.6431 25.3495 28.9822 24.2886 28.9822 22.9799V22.4659C28.9822 22.2996 28.9443 22.1373 28.8724 21.9806C28.3786 23.0565 26.2764 23.8649 23.7577 23.8649Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7577 26.5104C21.2391 26.5104 19.1369 25.7021 18.6431 24.6262C18.5712 24.7829 18.5332 24.9452 18.5332 25.1115V25.6254C18.5332 26.9341 20.8723 27.995 23.7577 27.995C26.6431 27.995 28.9822 26.9341 28.9822 25.6254V25.1114C28.9822 24.9451 28.9443 24.7828 28.8724 24.6261C28.3786 25.702 26.2764 26.5104 23.7577 26.5104Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15279_8291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.4e07cebe0d51cd2aba6c27ef8782db3e.svg";
export { ForwardRef as ReactComponent };